import {
  CLEAR_ERROR,
  FACE_PHOTO_CREATE_FAILED,
  FACE_PHOTO_CREATE_SUCCEEDED,
  FACE_PHOTO_GET_FAILED,
  FACE_PHOTO_GET_SUCCEEDED,
  CREATE_FACE_PHOTO_REQUESTED,
  GET_FACE_PHOTO_REQUESTED,
  DELETE_FACE_PHOTO_REQUESTED,
  FACE_PHOTO_DELETE_FAILED,
  FACE_PHOTO_DELETE_SUCCEEDED,
  FACE_PHOTO_GET_ALL_SUCCEEDED,
  FACE_PHOTO_GET_ALL_FAILED,
  GET_ALL_FACE_PHOTO_REQUESTED,
} from "../actions";

const defaultError = {
  facePhotoCreateError: false,
  facePhotoCreateFetching: false,
  facePhotoCreateSuccess: false,

  facePhotoDeleteError: false,
  facePhotoDeleteFetching: false,
  facePhotoDeleteSuccess: false,

  facePhotoGetError: false,
  facePhotoGetFetching: false,
  facePhotoGetSuccess: false,

  facePhotoGetAllError: false,
  facePhotoGetAllFetching: false,
  facePhotoGetAllSuccess: false,
};

const defaultState = {
  facePhoto: [],
  allfacePhotos: [],
  ...defaultError,
};

export default function (state = defaultState, action) {
  switch (action.type) {
    case CLEAR_ERROR:
      return {
        ...state,
        ...defaultError,
      };
    case CREATE_FACE_PHOTO_REQUESTED:
      return {
        ...state,
        facePhotoCreateFetching: true,
        facePhotoCreateError: false,
        facePhotoCreateSuccess: false,
      };
    case FACE_PHOTO_CREATE_FAILED:
      return {
        ...state,
        facePhotoCreateFetching: false,
        facePhotoCreateError: true,
        facePhotoCreateSuccess: false,
      };
    case FACE_PHOTO_CREATE_SUCCEEDED:
      return {
        ...state,
        facePhotoDetail: action.payload,
        facePhotoCreateFetching: false,
        facePhotoCreateError: false,
        facePhotoCreateSuccess: true,
      };

    case DELETE_FACE_PHOTO_REQUESTED:
      return {
        ...state,
        facePhotoDeleteFetching: true,
        facePhotoDeleteError: false,
        facePhotoDeleteSuccess: false,
      };
    case FACE_PHOTO_DELETE_FAILED:
      return {
        ...state,
        facePhotoDeleteFetching: false,
        facePhotoDeleteError: true,
        facePhotoDeleteSuccess: false,
      };
    case FACE_PHOTO_DELETE_SUCCEEDED:
      return {
        ...state,
        facePhotoDetail: action.payload,
        facePhotoDeleteFetching: false,
        facePhotoDeleteError: false,
        facePhotoDeleteSuccess: true,
      };

    case GET_FACE_PHOTO_REQUESTED:
      return {
        ...state,
        facePhotoGetFetching: true,
        facePhotoGetError: false,
      };
    case FACE_PHOTO_GET_FAILED:
      return {
        ...state,
        facePhotoGetFetching: false,
        facePhotoGetError: true,
      };
    case FACE_PHOTO_GET_SUCCEEDED:
      return {
        ...state,
        facePhoto: action.payload,
        facePhotoGetFetching: false,
        facePhotoGetError: false,
      };
    //get all
    case GET_ALL_FACE_PHOTO_REQUESTED:
      return {
        ...state,
        facePhotoGetAllFetching: true,
        facePhotoGetAllError: false,
      };
    case FACE_PHOTO_GET_ALL_FAILED:
      return {
        ...state,
        facePhotoGetAllFetching: false,
        facePhotoGetAllError: true,
      };
    case FACE_PHOTO_GET_ALL_SUCCEEDED:
      return {
        ...state,
        allfacePhotos: action.payload,
        facePhotoGetAllFetching: false,
        facePhotoGetAllError: false,
      };
    default:
      return state;
  }
}
